<template>
    <div class="form-field">
        <label>浮层</label>
        <div class="content">
            <!-- <el-checkbox-group> -->
                <!-- <el-radio :label="0">非浮层</el-radio> -->
                <el-checkbox :label="1" v-model="cover" @change="setCover">是</el-checkbox>
            <!-- </el-checkbox-group> -->
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .form-field{
        align-items: flex-start;
    }
</style>

<script>
	export default {
		props:['isCover'],
		data(){
			return {
				cover: !!this.isCover
            }
		},
		computed: {
			selected() {
				return this.$store.state.selected
			}
		},
		methods: {
			setCover(value) {
                this.$store.commit('update_elm', {
                	id: this.selected.id,
                    data: {
						isCover: value*1
                    }
                })
                this.$store.dispatch('elm_select',{id: this.selected.id})
			}
		},
        watch:{
			isCover(value){
				this.cover = !!value
            }
        }
	}
</script>
